import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL } from 'config/env.config'

export const POST_SIGNIN = 'BUSINESS/POST_SIGNIN'

const apiCall = enhancedMakeFetchAction(POST_SIGNIN, payload => ({
  endpoint: `${API_BASE_URL}/investcore-api/flex/v1/business/signin`,
  method: 'POST',
  body: payload,
  isStay: true
}))

export default apiCall
